"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Color = require("../core/Color");

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n\n  ", ";\n  ", ";\n\n  /* Extra specificity to override the is--module class */\n  && {\n    ", ";\n  }\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-attachment: local, local, scroll, scroll;\n  background-repeat: no-repeat;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    background-image: linear-gradient(to right, ", ", ", "),\n      linear-gradient(to left, ", ", ", "),\n      linear-gradient(to right, ", ", ", "),\n      linear-gradient(to left, ", ", ", ");\n    background-position: 0 0, 100% 0, 0 0, 100% 0;\n    background-size: 4em 100%, 4em 100%, 1em 100%, 1em 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      background-image: linear-gradient(to bottom, ", ", ", "),\n        linear-gradient(to top, ", ", ", "),\n        linear-gradient(to bottom, ", ", ", "),\n        linear-gradient(to top, ", ", ", ");\n      background-position: top, bottom, top, bottom;\n      background-size: 100% 4em, 100% 4em, 100% 1em, 100% 1em;\n      overflow-x: hidden;\n      overflow-y: auto;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var USE_CLASSES = {
  default: '',
  island: 'is--island'
};
var overhangDeprecationWarning = {
  message: 'UISection: The `overhang` prop is deprecated. Use `UIScrollContainer` instead.',
  key: 'UISection: overhang'
};

var scrollShadowGradient = function scrollShadowGradient(direction) {
  if (direction === 'vertical') {
    return (0, _styledComponents.css)(_templateObject(), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
  }

  return (0, _styledComponents.css)(_templateObject2(), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
};

var scrollShadowContainer = (0, _styledComponents.css)(_templateObject3());

var ScrollWrapper = _styledComponents.default.div.withConfig({
  displayName: "UISection__ScrollWrapper",
  componentId: "sc-7os49p-0"
})(_templateObject4(), function (props) {
  return (0, _Styles.toPx)(props.height);
}, function (props) {
  return props.overhang ? scrollShadowContainer : null;
}, function (props) {
  return props.overhang ? scrollShadowGradient(props.overhangDirection) : null;
}, function (props) {
  return props.flush && "margin-bottom: 0";
});

var hasPingedNewRelic = false;

var UISection = _react.default.createClass({
  displayName: "UISection",
  propTypes: {
    children: _react.PropTypes.node,
    flush: _react.PropTypes.bool.isRequired,
    height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
    overhang: (0, _deprecated.default)(_react.PropTypes.bool, overhangDeprecationWarning, false),
    overhangDirection: (0, _deprecated.default)(_react.PropTypes.oneOf(['horizontal', 'vertical']), overhangDeprecationWarning, 'horizontal'),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      flush: false,
      overhang: false,
      overhangDirection: 'horizontal',
      use: 'default'
    };
  },
  getClassName: function getClassName() {
    var _this$props = this.props,
        className = _this$props.className,
        overhang = _this$props.overhang,
        overhangDirection = _this$props.overhangDirection,
        use = _this$props.use;
    return (0, _classNames.default)('is--module', USE_CLASSES[use], className, 'namespaced-hack-section', {
      'private-scroll__wrapper--horizontal': overhang && overhangDirection === 'horizontal'
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        overhang = _this$props2.overhang,
        overhangDirection = _this$props2.overhangDirection,
        use = _this$props2.use,
        role = _this$props2.role,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "overhang", "overhangDirection", "use", "role"]);

    if (overhang) {
      _devLogger.default.warn(overhangDeprecationWarning);

      if (window.newrelic && !hasPingedNewRelic) {
        hasPingedNewRelic = true;
        window.newrelic.addPageAction('uisection-overhang');
      }
    }

    var computedRole = role === undefined && overhang ? 'region' : role;
    return _react.default.createElement(ScrollWrapper, (0, _extends2.default)({}, rest, {
      className: this.getClassName(),
      overhang: overhang,
      overhangDirection: overhangDirection,
      role: computedRole,
      tabIndex: overhang ? '0' : null,
      use: use
    }), children);
  }
});

var _default = UISection;
exports.default = _default;
module.exports = exports.default;